import React from 'react';
import { Badge, Avatar, Box, makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { map, get, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  characterImage: {
    width: '70px',
    height: '70px',
    backgroundColor: '#f2f2f2',
    boxShadow: '0px 0px 1px 1px #cdd2d2',
    border: '1px solid #cdd2d2',
    margin: '0.5rem',
    marginLeft: '0.7rem',
    marginRight: '0.7rem'
  },
  characterSlider: {
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'auto',
    alignItems: 'center',
    flexGrow: 1,
    marginTop: 0,
    height: '100%',
    padding: '0.5rem'
  },
  text: {
    backgroundColor: theme.palette.background.dark,
    color: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.background.dark}`,
    paddingLeft: '0.2rem',
    paddingRight: '0.2rem',
    marginLeft: '-14px',
    marginTop: '-14px',
    fontSize: '12px'
  }
}));

function UserProfileCharacterDisplay(props) {
  const classes = useStyles();
  const { characterAssets } = useSelector(state => state.gameAssets);

  return (
    <Box mt={2} classes={{ root: classes.characterSlider }}>
      {map(props.data, (charData, idx) => {
        return (
          <Badge
            key={charData.character}
            overlap="circle"
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            badgeContent={
              <Typography classes={{ root: classes.text }}>
                {charData.frequency}
              </Typography>
            }
          >
            <Avatar
              src={get(
                characterAssets[charData.character],
                'element_burst_talent'
              )}
              key={`${idx}-${charData.character}`}
              alt={charData.character}
              className={classes.characterImage}
            />
          </Badge>
        );
      })}
      {isEmpty(props.data) && (
        <Typography style={{ fontSize: '12px' }}>
          No information to display.
        </Typography>
      )}
    </Box>
  );
}

UserProfileCharacterDisplay.propTypes = {
  data: PropTypes.array.isRequired,
  classes: PropTypes.object
};

export default UserProfileCharacterDisplay;
